import { useRef, useMemo } from 'react';

export const useEffectDepChange = inputs => {
  let result = [];
  const oldInputsRef = useRef(inputs);
  const validationFields = Object.values(inputs);
  const inputKeysArray = Object.keys(inputs);
  const compareInputs = (inputKeys, oldInputs, newInputs) => {
    let res = [];
    inputKeys.forEach(key => {
      const oldInput = oldInputs[key];
      const newInput = newInputs[key];
      if (oldInput !== newInput) {
        res.push({ ...[key, oldInput, newInput] });
      }
    });
    return res;
  };

  useMemo(() => {
    const oldInputs = oldInputsRef.current;
    result = compareInputs(inputKeysArray, oldInputs, inputs);
    oldInputsRef.current = inputs;
  }, [...validationFields]);

  return result;
};
